import { object, SchemaOf, string } from "yup";
import { Spdr } from "../Spdr";
import { requiredFieldValidationMessage } from "../../../Forms/ValidationMessages";

export const spdrSchema: SchemaOf<Spdr> = object()
  .shape({
    SupplierGsdb: string().required(requiredFieldValidationMessage("Supplier")).default(""),
    PlantGsdb: string().required(requiredFieldValidationMessage("Plant")).default(""),
    DockCode: string()
      .required(requiredFieldValidationMessage("Dock"))
      .max(2, "Dock Code must be at most 2 characters")
      .default(""),
    ShipIndicator: string().required(requiredFieldValidationMessage("Ship Indicator")).default(""),
  })
  .required();
